import {
  getProductById,
  isProductLockedResponse,
  unlockProductLinkShare,
} from '@/Api';
import type { IProduct, ProductLockedResponse } from '@/types/Product.model';

export type AnnotationLinkedProductLoadResult =
  | { status: 'success'; product: IProduct }
  | { status: 'password_required'; locked: ProductLockedResponse }
  | { status: 'restricted'; locked: ProductLockedResponse }
  | { status: 'error' };

export async function loadAnnotationLinkedProduct(
  productId: string
): Promise<AnnotationLinkedProductLoadResult> {
  try {
    const loaded = await getProductById(productId);
    if (isProductLockedResponse(loaded)) {
      if (loaded.linkShareMode === 'restricted') {
        return { status: 'restricted', locked: loaded };
      }
      return { status: 'password_required', locked: loaded };
    }
    return { status: 'success', product: loaded };
  } catch {
    return { status: 'error' };
  }
}

export async function unlockAndLoadAnnotationLinkedProduct(
  productId: string,
  password: string
): Promise<AnnotationLinkedProductLoadResult> {
  try {
    await unlockProductLinkShare(productId, password);
    return loadAnnotationLinkedProduct(productId);
  } catch {
    return { status: 'error' };
  }
}
